export { default } from '@/features/campaignPage/Page/Label';
